export default {
  "meta": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])}
  },
  "hero": {
    "loader": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("progress")), "%"])},
    "scroller": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scroll to Explore"])}
  },
  "stack": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A simple childhood in tarbes."])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["France is renowned for its rich cultural heritage and sense of aesthetics, and growing up in a small town in France has shaped François' artistic sensibility and authenticity."])}
  },
  "next": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next Chapter"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap to continue"])}
  },
  "products": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View product page"])}
  },
  "carousel": {
    "slide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slide to view"])},
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
    "learn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Learn more"])}
  },
  "text": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View more"])}
  },
  "chapter-2": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["François Nars"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An inspired upbringing"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Born and raised in the south of France, François Nars spent his childhood poring over his mother's <em>Vogue</em> magazines and consuming classic Hollywood and European cinema. Guided by his passion for beauty and style, he attended Carita Makeup School in Paris."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-5.jpg"])}
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First & forever muses"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-3.jpg"])}
      }
    },
    "slice-3": {
      "text": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["François’ earliest—and most enduring—creative inspirations were the women in his life. Growing up, his mother, Claudette, and his grandmothers were bold examples of muses and mentors, demonstrating an unwavering strength of character and the liberating power of personal style."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“My beauty icons are my mother, my grandmothers, Garbo, and Dietrich.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["— François Nars, Founder & Creative Director"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editorial endeavors"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["At the encouragement of Polly Mellen, then-editor of American <em>Vogue</em>, François moved to New York City in 1984 to pursue editorial makeup work. His career would skyrocket as he shaped new standards of beauty for the pages of <em>Vogue</em>, <em>ELLE</em>, <em>Harper’s Bazaar</em>, and beyond."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-6.jpg"])}
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["RUNWAY STAR. <br/> RUNAWAY SUCCESS."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taking his talents to the runway, François collaborated with designers like Karl Lagerfeld and Marc Jacobs. In 1994, he launched a line of 12 lipsticks at Barneys New York to satisfy his own artistry needs. Met with immediate success, NARS Cosmetics was born."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-5.jpg"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The Nars Approach <br/>to artistry"])}
    }
  },
  "chapter-3": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The Nars <br/> Approach to <br/> Artistry"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brand beginnings"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iconic. Individual. Unexpected—NARS. Born of François’ fascination with color and texture, his original 12 lipsticks inspired a full cosmetics line designed to indulge women with his vision of beauty. Thirty years and countless products later, NARS continues to inspire."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-4.jpg"])}
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No-rules beauty"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A radiant complexion. A seductive smokey eye. A daring bold lip. The iconic NARS look is ever-evolving—and never boring."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-6.jpg"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-7.jpg"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-8.jpg"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-9.jpg"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-10.jpg"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The multiple"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspired by a 1996 <em>Harper’s Bazaar</em> photo shoot, The Multiple has been a beauty essential since its creation. Using only one lipstick color for the lips, cheeks, and eyes, François created a stunning monochromatic look, starting a phenomenon around effortless artistry."])},
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Face it all"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From detailed face charts to core beauty philosophies, NARS Artistry is as much about communicating a vision as it is creating it."])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-1.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monochromatic color"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our take on the viral monochromatic makeup look, featuring a wash of color on the cheeks and across the nose, lips glazed in a pop of pink, and eyes sparkling in rose tones."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“With subtle or intense color, you can never go wrong.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Founder & Creative Director"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-2.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Power of neutrals"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neutral shades have never looked bolder, featuring blush applied in a boomerang shape along the cheek, eyes adorned in copper tones, and a ’90s-inspired nude lip."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Neutrals allow the world to see your face and personality as it is, enhancing your natural beauty.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Founder & Creative Director"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-3.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fully loaded lip"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A bold, matte lip is classic and elegant, balanced here by a signature NARS defined eye with a bit of smoke and warm-toned, sculpted cheeks."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“A strong lip always adds power to your look.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Founder & Creative Director"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-4.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ethereal glow"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A soft lip paired with lightly defined, ’60s-inspired eyes brings to life an ethereal look, while warm and cool tones paired together on cheeks gives skin a dreamy, second-skin glow."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Lips that are soft, yet intense—it’s an absolutely powerful look.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Founder & Creative Director"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-5.jpg"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smoke show"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An intense plum eye with a high-shine lip creates a trendy yet sophisticated take on the classic smoky eye with a pop of sparkle."])},
        "quote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["“Eye makeup allows for the most creativity of all cosmetics. The key is blending.”"])},
        "author": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["—François Nars, Founder & Creative Director"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A prolific career"])}
    }
  },
  "chapter-4": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A Prolific <br/> Career"])},
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<strong>François</strong> <strong>NARS: </strong><br/>\n<strong>From</strong> <strong>the</strong> <strong>Archives</strong>"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A visionary image-maker, François has built an extensive catalog of photographic work over the years, culminating in a documentary feature about his life and accomplishments."])}
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DISCOVER THE COLLECTION"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X-RAY (1999)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>X-RAY</em> (1999)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS 15x15 (2009)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em> NARS 15x15</em> (2009)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND: EXPRESS YOURSELF - 2011"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>MAKEUP YOUR MIND:<br/>\nEXPRESS YOURSELF</em> (2011)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["faery lands (2013)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>faery lands</em> (2013)"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FRANÇOIS NARS (2016)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>FRANÇOIS NARS</em> (2016)"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PERSONA (2021)"])},
        "caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<em>PERSONA</em> (2021)"])}
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X-RAY"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1999"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A collection of elegant and stylized portraits of those whose incomparable style has inspired François, including Diane von Furstenberg, Carine Roitfeld, Boy George, and more."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GRACE JONES"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DIANE VON FURSTENBERG"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CHRISTY TURLINGTON"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["EARTHA KITT"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carine Roitfeld"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boy George"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liza Minnelli"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manolo Blahnik"])}
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS 15X15"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2009"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A limited-edition book of celebrity portraits inspired by iconic NARS shade names to commemorate the 15th anniversary of NARS Cosmetics."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MARC JACOBS"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NAOMI CAMPBELL"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AMBER VALLETA"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DAYLE HADDON"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["daphne guinness"])}
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND: EXPRESS YOURSELF"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2011"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A beauty manual offering advanced makeup techniques, precise instruction, and vivid “before” and “after” portraits."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["http://mauersberger-recht.de/USA/makeup-your-mind%3A-express-yourself/0607845032045.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2011)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2011)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2011)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2011)"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2011)"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["MAKEUP YOUR MIND (2011)"])}
      }
    },
    "slice-6": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2013"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A mesmerizing photography collection of Motu Tane, the private island in French Polynesia whose scenery, people, and culture provide François with a limitless source of inspiration."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 1"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 2"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 3"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 4"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 5"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 6"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 7"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 8"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-9.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 9"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-10.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 10"])}
      },
      "image-11": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-11.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faery lands - 11"])}
      }
    },
    "slice-7": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2016"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A captivating photo biography that tells the fascinating story of François Nars, his rebellious vision, and his world of remarkable beauty."])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      }
    },
    "slice-8": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["persona"])},
      "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2021"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A limited-edition book of eclectic portraits photographed by François Nars featuring creative figures of all ages."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["http://mauersberger-recht.de/USA/persona-book/0194251071077.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["françois nars (2016)"])}
      }
    },
    "slice-9": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<strong>Unknown Beauty: <br/>François Nars</strong>"])},
      "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DIRECTED BY LISA IMMORDINO VREELAND"])},
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-1.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 1"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-2.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 2"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-3.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 3"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-4.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 4"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-5.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 5"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-6.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 6"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-7.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 7"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-8.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 8"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-9.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 9"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-10.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Francois Nars Documentary 10"])}
      }
    },
    "slice-10": {
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A full-length documentary feature that provides a rare glimpse into the life of Founder and Creative Director, François Nars, and the enduring inspirations that have fueled him since childhood."])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://www.amazon.com/Beauty-Fran%C3%A7ois-Nars-Charlotte-Rampling/dp/B0C9VQMC8S"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Watch now"])}
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_next_image.jpg"])},
        "alt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["THE NARS ICONS"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["THE NARS ICONS"])}
    }
  },
  "chapter-5": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The NARS icons"])},
    "slice-0": {
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover the NARS icons that spark your inner artist, all designed to add endless character and personality to your routine. Pushing boundaries then, now, forever."])}
    },
    "slice-1": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light Reflecting<sup>TM</sup> Setting Powder"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS’ instant cult-classic that set the stage for luminous, Light Reflecting<sup>TM</sup> skin."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No-flashback formula locks in your look with a photo-ready finish, featuring Photochromic Technology to diffuse and adjust to new sources of light so skin looks perfect in person, and on camera. Never dim your light."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["http://mauersberger-recht.de/USA/light-reflecting-pressed-setting-powder/999NAC0000099.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        }
      },
      "image-5": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        }
      }
    },
    "slice-2": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blush"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our cult-favorite cheek color, now available in an upgraded formula, pops, sculpts, and highlights for up to 16 hours of silky, weightless wear."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pure Pigment Blend achieves true-color payoff with an innovative combination of four blendable pigments that make an impact while helping to blur the look of imperfections."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["http://mauersberger-recht.de/USA/powder-blush/999NAC0000192.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        }
      }
    },
    "slice-3": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Explicit lipstick"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meet the new icon in sustainable luxury."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A refillable, precision-tip bullet glides on for sculpted sophistication with a single swipe, while our Rosehip Seed Oil- and Hyaluronic Acid-spiked Luxe Comfort Complex hugs lips for lightweight, medium-to-full creamy coverage. Classic color meets unexpected character to polish and provoke for elevated elegance—with an edge."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["http://mauersberger-recht.de/USA/explicit-lipstick/999NAC0000221.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        }
      }
    },
    "slice-4": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Light Reflecting<sup>TM</sup> Foundation"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Often imitated, but never duplicated, our award-winning formula is the ultimate leader in luminosity."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This makeup-skincare hybrid foundation instantly blurs imperfections and smooths the look of textured skin while visibly improving skin’s clarity over time. Medium, buildable coverage with breathable, all-day wear ensures that skin is enhanced, never masked."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["http://mauersberger-recht.de/USA/light-reflecting%E2%84%A2-advanced-skincare-foundation/999NAC0000141.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        }
      }
    },
    "slice-5": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radiant Creamy Concealer"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coveted by artists and non-artists alike, this multi-purpose must-have is beloved for its effortless, everyday use."])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An ultra-luxurious texture infused with our Multi-Active Botanical Blend provides a luminous finish that helps skin retain vital moisture for 24 hours of hydration. Unique powders help even out skin tone and blur the appearance of imperfections for 16-hours of hard-working wear in 30 skin tone-spanning shades. Brighten, correct, and perfect."])},
      "url": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["http://mauersberger-recht.de/USA/radiant-creamy-concealer/999NACRCC0001.html"])},
      "cta_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        }
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_next.jpg"])}
      },
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Then. Now. NARS."])}
    }
  },
  "blocker": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PLEASE ROTATE <br/>YOUR SCREEN"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AVAILABLE ONLY IN PORTRAIT MODE"])}
  }
}